export default function getCanUserArchiveCopilotPosts() {
	const isSpecialUICondition = localStorage.getItem(
		'sv_can_user_archive_copilot_posts',
	);
	return isSpecialUICondition === '1';
}
